import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {useAuth0} from "@auth0/auth0-react";

// Recoil
import {useRecoilValue} from "recoil";
import {userState} from "recoil/globalStates";

// MUI
import {Button, Link, ListItemText, Menu} from "@mui/material";
import {FormatListBulleted} from "@mui/icons-material";

// Local
import StyledMenuItem from "elements/styledMenuItem";

export default function ManageMenu({menuItems}) {
  const {t} = useTranslation();
  const {isAuthenticated, loginWithRedirect} = useAuth0();
  const dbUser = useRecoilValue(userState);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const items = menuItems.map((item, idx) => (
    <StyledMenuItem key={item.href || idx} divider component={Link} href={item.href}>
      <ListItemText primary={item.label} />
    </StyledMenuItem>
  ));
  
  const handleClick = (event) => {
    if (isAuthenticated) {
      setAnchorEl(event.currentTarget);
    } else {
      loginWithRedirect();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button name="manage" color="white" onClick={handleClick} startIcon={<FormatListBulleted />}>
        {t("manage")}
      </Button>
      <Menu id="manage" anchorEl={anchorEl} open={open} onClose={handleClose}>
        {items}
      </Menu>
    </>
  );
}
